import { SVGInterface } from "../../interface";

const Reports = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M6 2.94116C4.90575 2.94116 4 3.84691 4 4.94116V20.9412C4 22.0354 4.90575 22.9412 6 22.9412H18C19.0943 22.9412 20 22.0354 20 20.9412V8.94116L14 2.94116H6ZM6 4.94116H13V9.94116H18V20.9412H6V4.94116ZM8 12.9412V14.9412H16V12.9412H8ZM8 16.9412V18.9412H16V16.9412H8Z"
      fill={color || "#0E171F"}
    />
  </svg>
);
export default Reports;
